import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import UnderlayEmbed from './underlay-app-embed';

@NgModule({
    declarations: [
        UnderlayEmbed,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        TranslateModule,
        RouterModule
    ],
    providers: [

    ],
    exports: [
        UnderlayEmbed
    ]
})

export class UnderlayModule {
    constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/components/underlay-app/underlay-app.module.ts